/**
 * PipelineFilters - Filter bar above the Kanban board.
 * Search by title/company, sort by score/date/company, display total count.
 */

interface PipelineFiltersProps {
  search: string;
  sortBy: 'score' | 'date' | 'company';
  totalCount: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: 'score' | 'date' | 'company') => void;
}

export function PipelineFilters({
  search,
  sortBy,
  totalCount,
  onSearchChange,
  onSortChange,
}: PipelineFiltersProps) {
  return (
    <div className="pipeline-filters">
      {/* Search input with icon */}
      <div className="pipeline-filters__search-wrapper">
        <svg
          className="pipeline-filters__search-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          type="text"
          className="pipeline-filters__search-input"
          placeholder="Search jobs..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search jobs by title or company"
        />
      </div>

      {/* Sort dropdown */}
      <select
        className="pipeline-filters__sort"
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value as 'score' | 'date' | 'company')}
        aria-label="Sort jobs"
      >
        <option value="date">Sort by Date</option>
        <option value="score">Sort by Score</option>
        <option value="company">Sort by Company</option>
      </select>

      {/* Total count */}
      <span className="pipeline-filters__count">
        {totalCount} {totalCount === 1 ? 'job' : 'jobs'}
      </span>
    </div>
  );
}
